import PropTypes from 'prop-types'
import { MERCADO_PAGO } from '../../../constants/mediosEnviosPagos.js'
import {
  ID_ESTADO_CANCELADO,
  ID_ESTADO_DEVUELTO,
  ID_ESTADO_NO_CONFIRMADO
} from '../../../constants/pedidoEstados.js'
import { useAuth } from '../../../hooks/useAuth.js'
import { formatearFecha } from '../../helpers/helper'
import LinkButton from '../../ui/LinkButton'
import styles from './Pedido.module.css'

export const PedidoBody = ({
  fechaPedido,
  pedidoItem,
  esVentas,
  tienePercepcionesPendientes,
  esAdministrador
}) => {
  const {
    idPublicacion,
    idVendedor,
    idPedidoItem,
    fechaDespachado,
    esItemCalificado,
    fechaRecibido,
    estadoNombre,
    descripcionEstado,
    medioPago,
    tipoPagoMP,
    idMedioPago,
    compradorNombre,
    vendedorNombre,
    compradorRazonSocial,
    vendedorRazonSocial
  } = pedidoItem

  const { esPerfilAdmin } = useAuth()
  const nombreContraparte = esVentas ? vendedorNombre : compradorNombre
  const razonSocialContraparte = esVentas ? vendedorRazonSocial : compradorRazonSocial
  const productoYaCalificado = esItemCalificado === 1

  const pathCalificarProducto = `/CalificarProducto/${idPublicacion}/${idVendedor}/${idPedidoItem}`
  const pathDetallePedidoItem = {
    pathname: `/PedidoItem/${idPedidoItem}`,
    state: { origen: esVentas ? '/Ventas' : '/Pedidos' }
  }

  let descripcionPedido = ''

  if (esVentas && tienePercepcionesPendientes) {
    descripcionPedido = 'para editar y confirmar los montos ir a "Gestionar pedido"'
  } else if (descripcionEstado) {
    descripcionPedido = descripcionEstado
  }

  return (
    <div className={styles.pedidoBody}>
      <div>
        <div className={styles.pedidoDescripcion}>
          <span>
            <i className="fa fa-calendar-o" aria-hidden="true" />
            <strong>Compra:</strong> {formatearFecha(fechaPedido, 'F')}
          </span>
          <span>
            <i className="fa fa-truck" aria-hidden="true" />
            <strong>Enviado:</strong> {formatearFecha(fechaDespachado, 'F')}
          </span>
          <span>
            <i className="fa fa-gift" aria-hidden="true" />
            <strong>Entregado:</strong> {formatearFecha(fechaRecibido, 'F')}
          </span>
          <span>
            <i className="fa fa-credit-card" aria-hidden="true"></i>
            <strong>Método de pago:</strong>{' '}
            {tipoPagoMP && idMedioPago === MERCADO_PAGO && `${tipoPagoMP} mediante `}
            {medioPago || ''}
          </span>
          {esPerfilAdmin && (
            <span>
              <i className="fa fa-user bigger-icon mr-2" aria-hidden="true" />{' '}
              <strong>{esVentas ? 'Vendedor' : 'Comprador'}:</strong> {nombreContraparte}
              {razonSocialContraparte && ` (${razonSocialContraparte})`}
            </span>
          )}
        </div>
        <div
          className={` ${styles.estado} ${
            [ID_ESTADO_NO_CONFIRMADO, ID_ESTADO_DEVUELTO, ID_ESTADO_CANCELADO].includes(
              pedidoItem.idPedidoItemEstado
            )
              ? styles.estadoNoOk
              : ''
          }`}
        >
          <strong>Estado del envío: </strong>
          <span>
            {estadoNombre}
            {descripcionPedido ? ` (${descripcionPedido})` : ''}
          </span>
        </div>
      </div>
      {!esAdministrador && (
        <div className={styles.items}>
          {!esVentas && (
            <LinkButton
              to={pathCalificarProducto}
              className={`${styles.califButton} ${productoYaCalificado ? styles.disabledButton : ''}`}
            >
              <i className="fa fa-star" aria-hidden="true" />
              Calificar Producto
            </LinkButton>
          )}
          <LinkButton to={pathDetallePedidoItem} className={styles.califButton}>
            <i className="fa fa-search" aria-hidden="true" />
            Ver Detalle
          </LinkButton>
        </div>
      )}
    </div>
  )
}

PedidoBody.propTypes = {
  fechaPedido: PropTypes.string.isRequired,
  pedidoItem: PropTypes.shape({
    idPublicacion: PropTypes.number,
    idVendedor: PropTypes.number,
    idPedidoItemEstado: PropTypes.number,
    idPedidoItem: PropTypes.number,
    fechaDespachado: PropTypes.string,
    esItemCalificado: PropTypes.number,
    esVendedorCalificado: PropTypes.number,
    fechaRecibido: PropTypes.string,
    estadoNombre: PropTypes.string,
    descripcionEstado: PropTypes.string,
    idMedioPago: PropTypes.number,
    medioPago: PropTypes.string,
    tipoPagoMP: PropTypes.string,
    compradorNombre: PropTypes.string,
    vendedorNombre: PropTypes.string,
    compradorRazonSocial: PropTypes.string,
    vendedorRazonSocial: PropTypes.string
  }).isRequired,
  esVentas: PropTypes.bool.isRequired,
  tienePercepcionesPendientes: PropTypes.bool.isRequired,
  esAdministrador: PropTypes.bool
}
